import React from 'react'
import {Address, PaymentMethod} from './customer'
import OrderCard from './OrderCard'
import {deliveryTypes} from 'app/constant'
import {KTSVG} from '_metronic/helpers'
import {typesPayment} from '../../models'
import {CustomerName} from 'app/components/customer/CustomerInfo'
import {startCase, lowerCase} from 'lodash'
import GiftMessage from '../../components/customer/GiftMessage'

interface Props {
  toolbar?: any
  shippingAddress: any
  billingAddress: any
  paymentMethod: any
  children: React.ReactNode
  orderDeliveryMethod: string
  firstName: string | null
  lastName: string | null
  hasWineClub?: boolean
  paymentType?: string
  isDraftOrder?: boolean
  orderCustomer?: any
  giftMessage?: any
  customerName?: string
}

export const CustomerCard: React.FC<Props> = ({
  toolbar,
  shippingAddress,
  billingAddress,
  paymentMethod,
  orderDeliveryMethod,
  children,
  firstName,
  lastName,
  hasWineClub,
  paymentType,
  isDraftOrder,
  orderCustomer,
  giftMessage,
  customerName,
}) => {
  const getName = () => {
    if (customerName) {
      return <CustomerName customerName={customerName} />
    }
    if (orderCustomer && orderCustomer.name) {
      return `${startCase(lowerCase(orderCustomer.name))} (Guest)`
    }
    if (firstName && lastName) {
      return <CustomerName firstName={firstName} lastName={lastName} />
    }
    return 'Customer'
  }

  const pmElement = (
    <>
      <PaymentMethod title='Payment Method' paymentMethod={paymentMethod} />
      <Address title='Billing Address' address={billingAddress} />
    </>
  )
  return (
    <OrderCard
      title={
        <>
          {' '}
          {getName()}
          {hasWineClub && (
            <span className='svg-icon svg-icon-1 ms-2 '>
              <KTSVG
                path='/media/icons/corksy/crown.svg'
                className='svg-icon-warning svg-icon-2 p-0 m-0 pb-1'
              />
            </span>
          )}
        </>
      }
      className='pt-5'
      toolbar={toolbar}
    >
      {children}
      {orderDeliveryMethod === deliveryTypes.ship && (
        <Address title='Shipping Address' address={shippingAddress} />
      )}
      {isDraftOrder ? (
        <>{paymentType === typesPayment.card && <>{pmElement}</>}</>
      ) : (
        <>{pmElement}</>
      )}
      <GiftMessage message={giftMessage} />
    </OrderCard>
  )
}

export default CustomerCard
